import { Download, RefreshCw, Users, DollarSign, Clock } from "lucide-react";
import { STATUS_STYLES } from "./shared";

export default function RegistrationsTab({ ctx }) {
  const {
    data, search, setSearch, loading, token,
    loadAll, exportCSV, setViewing, filteredRegistrations,
  } = ctx;
  if (!data) return null;
  return (
    <>
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-white">Registrations</h1>
        <div className="flex items-center gap-3">
          <button data-testid="admin-export-btn" onClick={exportCSV} disabled={!data.registrations.length}
            className="inline-flex items-center gap-2 text-sm font-bold text-white bg-[#2563EB] hover:bg-[#1d4fd7] disabled:opacity-40 rounded-full px-4 py-2.5 transition-colors">
            <Download size={15} /> Export CSV
          </button>
          <button data-testid="admin-refresh-btn" onClick={() => loadAll(token)} disabled={loading}
            className="inline-flex items-center gap-2 text-sm font-bold text-white/70 hover:text-white border border-white/15 rounded-full px-4 py-2.5 transition-colors">
            <RefreshCw size={15} className={loading ? "animate-spin" : ""} /> Refresh
          </button>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          { icon: Users, label: "Paid Registrations", value: data.summary.total_paid },
          { icon: DollarSign, label: "Revenue", value: `$${data.summary.total_revenue.toLocaleString()}` },
          { icon: Clock, label: "Pending / Incomplete", value: data.summary.pending },
        ].map((st) => (
          <div key={st.label} className="rounded-2xl bg-white/5 border border-white/10 p-6">
            <st.icon size={20} className="text-[#2563EB]" />
            <p className="mt-4 text-4xl font-extrabold tracking-tighter text-white">{st.value}</p>
            <p className="mt-1 text-sm font-semibold text-white/50">{st.label}</p>
          </div>
        ))}
      </div>

      {Object.keys(data.summary.by_league || {}).length > 0 && (
        <div className="mt-4 rounded-2xl bg-white/5 border border-white/10 p-6">
          <p className="text-sm font-bold uppercase tracking-wider text-white/40">Paid by League</p>
          <div className="mt-4 flex flex-wrap gap-3">
            {Object.entries(data.summary.by_league).map(([lg, count]) => (
              <span key={lg} className="inline-flex items-center gap-2 rounded-full bg-[#2563EB]/15 text-white px-4 py-2 text-sm font-bold">
                {lg} <span className="text-[#60a5fa]">{count}</span>
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="mt-6">
        <input
          data-testid="reg-search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search player, parent, or email…"
          className="w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-3.5 text-white placeholder-white/30 outline-none focus:border-[#2563EB] transition-colors"
        />
      </div>

      <div className="mt-4 rounded-2xl bg-white/5 border border-white/10 overflow-hidden">
        <div className="grid grid-cols-12 px-5 md:px-6 py-4 text-xs font-bold uppercase tracking-wider text-white/40 border-b border-white/10">
          <span className="col-span-4 md:col-span-3">Player</span>
          <span className="hidden md:block md:col-span-2">Division</span>
          <span className="col-span-4 md:col-span-3">Parent</span>
          <span className="col-span-2 md:col-span-2">Status</span>
          <span className="col-span-2 md:col-span-2 text-right">Waiver</span>
        </div>
        {filteredRegistrations.length === 0 && (
          <p data-testid="admin-empty" className="px-6 py-10 text-center text-white/40 font-medium">No registrations found.</p>
        )}
        {filteredRegistrations.map((r, i) => (
          <button key={r.id || i} data-testid={`registration-row-${i}`} onClick={() => setViewing(r)}
            className="w-full text-left grid grid-cols-12 items-center px-5 md:px-6 py-4 border-t border-white/5 hover:bg-white/5 transition-colors">
            <span className="col-span-4 md:col-span-3 text-sm font-bold text-white truncate pr-2">{r.player?.first_name} {r.player?.last_name}</span>
            <span className="hidden md:block md:col-span-2 text-sm font-medium text-white/60">{r.division || "—"}</span>
            <span className="col-span-4 md:col-span-3 text-sm font-medium text-white/60 truncate pr-2">{r.parent?.email || "—"}</span>
            <span className="col-span-2 md:col-span-2">
              <span className={`inline-block rounded-full px-3 py-1 text-xs font-bold ${STATUS_STYLES[r.payment_status] || "bg-white/10 text-white/50"}`}>{r.payment_status}</span>
            </span>
            <span className="col-span-2 md:col-span-2 text-right text-sm font-bold">
              {r.waiver?.signature_name ? <span className="text-[#60a5fa]">Signed</span> : <span className="text-white/30">—</span>}
            </span>
          </button>
        ))}
      </div>
    </>
  );
}
